import { Model as ORMModel, attr, many } from 'redux-orm'
import { Types } from '@fedsim/actions'

export class Feud extends ORMModel {
    static get fields() {
        return {
            id: attr(),

            name: attr({ getDefault: () => '' }),
            desc: attr({ getDefault: () => '' }),
            image: attr({ getDefault: () => '' }),

            startDate: attr({ getDefault: () => new Date() }),
            endDate: attr({ getDefault: () => new Date() }),

            intensity: attr({ getDefault: () => 1 }), // 1 - 5 - modifier on injury chance
            stageId: attr({ getDefault: () => 0 }),
            maxStages: attr({ getDefault: () => 5 }),
            complete: attr({ getDefault: () => false }),

            storylineId: attr({ getDefault: () => 0 }),
            wrestlerIds: many({
                to: 'Wrestler',
                as: 'wrestlers',
                relatedName: 'FeudWrestlers'
            }),
            winnerIds: many({
                to: 'Wrestler',
                as: 'winners',
                relatedName: 'FeudWinners'
            }),
            brandIds: many({
                to: 'Brand',
                as: 'brands',
                relatedName: 'FeudBrands'
            }),
            championshipIds: many({
                to: 'Championship',
                as: 'championships',
                relatedName: 'FeudChampionships'
            })
        }
    }

    static reducer(action, Feud, session) {
        let item
        switch (action.type) {
            case Types.RESET:
            case Types.RESET_FEUDS:
                session.Feud.all()
                    .toModelArray()
                    .forEach(item => item.delete())
                break

            case Types.NEXT_STAGE:
                item = Feud.withId(action.payload.id)

                if (item && item.stageId < item.maxStages) {
                    const stageId = item.stageId + 1

                    item.update({ ...action.payload, stageId })
                }

                break
            case Types.PREVIOUS_STAGE:
                item = Feud.withId(action.payload.id)

                if (item) {
                    const stageId = item.stageId + 1

                    item.update({ ...action.payload, stageId })
                }
                break
            case Types.COMPLETE_FEUD:
                item = Feud.withId(action.payload.id)
                const stageId = item.stageId + 1
                const complete = true

                if (item) {
                    item.update({ ...action.payload, stageId, complete })
                }

                break
            case Types.RESET_STAGE:
                item = Feud.withId(action.payload.id)
                if (item) {
                    item.update({ ...action.payload, stageId: 0, complete: false })
                }

                break
            case Types.ADD_FEUD: {
                item = action.payload.id ? Feud.withId(action.payload.id) : false
                if (!item) {
                    Feud.upsert(action.payload)
                }
                break
            }
            case Types.GENERATE_FEUDS:
                action?.payload.forEach(newItem => {
                    session.Feud.upsert(newItem)
                })
                break
            case Types.UPDATE_FEUD:
                item = Feud.withId(action.payload.id)
                if (item) {
                    item.update(action.payload)
                }
                break
            case Types.DELETE_FEUD: {
                Feud.withId(action.payload.id).delete()
                break
            }
        }
    }
}

export default Feud
